<div id="hub-footer-cont">
  <div id="link-bar">
    <div class="inner-cont">
      <div class="inner-cont-left">
          <div class="item-devider"></div>
        <div class="footer-item"><i class="icon icon-security-lock"></i><!--<span class="security-lock-icon custom-icon"></span>--><a (click)="footerLinksNavigate('ONLINE_SECURITY')">Online Security</a></div>
        <div class="item-devider"></div>
        <div class="footer-item"><i class="icon icon-global"></i><!--<span class="global-icon custom-icon"></span>--><a (click)="footerLinksNavigate('HSBC_GROUP')">HSBC Group</a></div>
        <div class="item-devider"></div>
        <div class="footer-item"><i class="icon icon-phone"></i><!--<span class="phone-icon custom-icon"></span>--><a (click)="footerLinksNavigate('CUSTOMER_SUPPORT')">Customer Support</a></div>
      </div>
      <div class="inner-cont-right">
        <!-- <div class="footer-item">Copyright HSBC Group 2019</div> -->
      </div>
    </div>
  </div>

  <div id="tnc-bar">
      <div class="inner-cont">
        <div class="inner-cont-left">
          <div class="footer-item"><a (click)="footerLinksNavigate('TERMS_AND_CONDITIONS')">Terms & Conditions of use</a></div>
          <div class="footer-item"><a (click)="footerLinksNavigate('PRIVACY_AND_DATA')">Privacy and data protection statement</a></div>
          <div class="footer-item"><a (click)="footerLinksNavigate('HSBCNET_CONDITIONS')">HSBCnet condition of national language use</a></div>
        </div>
        <div class="inner-cont-right">
          <div class="footer-item">© HSBC Bank plc 2019</div>
        </div>
      </div>
  </div>
</div>